import { render, staticRenderFns } from "./data-table.vue?vue&type=template&id=5e3b3551&scoped=true"
import script from "./data-table.vue?vue&type=script&lang=ts"
export * from "./data-table.vue?vue&type=script&lang=ts"
import style0 from "./data-table.vue?vue&type=style&index=0&id=5e3b3551&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3b3551",
  null
  
)

export default component.exports